import Hero from "@/components/sections/Hero";
import HowItWorks from "@/components/sections/HowItWorks";
import Features from "@/components/sections/Features";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";
import CTABanner from "@/components/sections/CTABanner";

const HomePage = () => (
  <main data-testid="home-page">
    <Hero />
    <HowItWorks />
    <Features />
    <Pricing />
    <FAQ />
    <CTABanner />
  </main>
);

export default HomePage;
